/**
 * Typen für die Listenverwaltung
 */

export interface ListMetadata {
  updatedAt: string;
  updatedBy: string;
}

export type ListType = 'simple' | 'valueNamePair' | string;

export interface ListConfig {
  name: string;
  displayName: string;
  type: ListType;
  defaultData: any[];
}
